import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1210782a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "up-candle"
};
const _hoisted_2 = {
  key: 1,
  class: "percentage"
};
const _hoisted_3 = {
  class: "down-candle"
};
const _hoisted_4 = {
  key: 1,
  class: "percentage"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_percentage_value = _resolveComponent("percentage-value");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["revenue-evolution-candle", {
      isLastest: $props.isLastest
    }]),
    onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.onHovering && $options.onHovering(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.onLeaving && $options.onLeaving(...args))
  }, [_createElementVNode("div", _hoisted_1, [$props.data >= 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle({
      height: $options.height
    }),
    class: _normalizeClass(["candle", {
      isLastest: $props.isLastest
    }])
  }, null, 6)) : $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_percentage_value, {
    value: $props.data,
    style: {
      "color": "#e7747a"
    }
  }, null, 8, ["value"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [$props.data < 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle({
      height: $options.height
    }),
    class: _normalizeClass(["candle", {
      isLastest: $props.isLastest
    }])
  }, null, 6)) : $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_percentage_value, {
    value: $props.data,
    style: {
      "color": "#22863d"
    }
  }, null, 8, ["value"])])) : _createCommentVNode("", true)])], 34);
}